import { BASE } from "./index";
import axios from "./http";

const examine = {
    //审核商品列表
    productlist: (params) =>axios.post(`${BASE.PRO1}/categories/audit/product/list`,  params ),
    //审核商品列表
    sortsave: (params) =>axios.post(`${BASE.PRO1}/audit/product/sort/save`,  params ),
    //审核商品列表分类参数
    producttotal: (params) =>axios.post(`${BASE.PRO1}/categories/audit/product/total`,  params ),
    //审核商品通过驳回
    producthandle: (params) =>axios.post(`${BASE.PRO1}/categories/audit/product/handle`,  params ),
    //下架原因列表
    producttakeoffreason: (params) =>axios.post(`${BASE.PRO1}/categories/audit/product/takeoff/reason`,  params ),
    //获取一级分类
    firstlist: (params) =>axios.post(`${BASE.PRO1}/categories/first/list`,  params ),
    //列表
    downconfiglist: (params) =>axios.post(`${BASE.PRO1}/product/take/down/config/list`,  params ),
    //保存
    downconfigsave: (params) =>axios.post(`${BASE.PRO1}/product/take/down/config/save`,  params ),
    //详情
    downconfigdetail: (params) =>axios.post(`${BASE.PRO1}/product/take/down/config/detail`,  params ),
    //移除
    downconfigremove: (params) =>axios.post(`${BASE.PRO1}/product/take/down/config/remove`,  params ),
    //商品白名单列表
    downwhitelist: (params) =>axios.post(`${BASE.PRO1}/product/take/down/white/list`,  params ),
    //商品白名单列表移除
    downwhiteremove: (params) =>axios.post(`${BASE.PRO1}/product/take/down/white/remove`,  params ),
    //商品白名单列表选品
    downwhiteselect: (params) =>axios.post(`${BASE.PRO1}/product/take/down/white/select`,  params ),
    //商品白名单添加
    downwhiteadd: (params) =>axios.post(`${BASE.PRO1}/product/take/down/white/add`,  params ),
    //商品白名单添加
    downtakeoff: (params) =>axios.post(`${BASE.PRO1}/product/state/takeoff`,  params ),
};

export default examine;
